import { EAssetType } from 'constants/enums';
import { TRIGGERED_POPUP_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';

import { GradientFieldConfig, UploadFieldConfig } from '../FormFields.types';

export const FONT_WEIGHT_OPTIONS = [
  { value: 'normal', label: 'Regular' },
  { value: 'medium', label: 'Medium' },
  { value: 'bold', label: 'Bold' }
];

export const BG_COLOR_FIELDS: GradientFieldConfig[] = [
  {
    header: 'Background Color',
    name: 'backgroundColor',
    fallback: TRIGGERED_POPUP_DEFAULTS.backgroundColor
  }
];

export const UPLOAD_FIELDS: UploadFieldConfig[] = [
  {
    title: 'Background Image',
    fieldName: 'backgroundImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Upload a background image for the triggered popup',
    isRequired: true
  },
  {
    title: 'Badge Cover Image',
    fieldName: 'badgeCoverImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Upload a badge cover image for the triggered popup'
  }
];

export const TITLE_DEFAULTS = {
  fontColor: TRIGGERED_POPUP_DEFAULTS.fontColor,
  fontSize: TRIGGERED_POPUP_DEFAULTS.fontSize
};
